import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Header from '../../layout/Header.jsx';
import FormTraining from '../../forms/FormTraining.jsx';

const PageTraining = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  const breadcrumb = [
    { children: 'Trainings', to: '/admin/trainings' },
    { children: _id === 'new' ? 'Create New' : 'Edit' },
  ];

  useEffect(() => {
    if (_id !== 'new') {
      req({
        url: `/api/quiz/trainings/${_id}`,
      });
    }
  }, [_id]);

  return _id === 'new' ? (
    <div>
      <Header breadcrumb={breadcrumb}>Create New</Header>
      <FormTraining />
    </div>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormTraining training={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PageTraining;
